import { Skeleton } from '@shared/components/shadcn';
import { getSiteConfig } from '@shared/config';
import { twMerge } from '@shared/themes';
import { InnerPageContainer } from '../../../InnerPageContainer/InnerPageContainer';
import { PURCHASE_CONTAINER_CLASSES } from '../PurchasedTickets';
import { LoadingPodsSkeleton } from './LoadingPodsSkeleton';

function LoadingPurchasedTickets() {
  const { showsTicketStateSwitcher } = getSiteConfig().LOTTERY_PURCHASES;

  return (
    <InnerPageContainer>
      <div data-testid="loading-purchased-tickets" className={twMerge(PURCHASE_CONTAINER_CLASSES.GRID, 'flex flex-col gap-6 p-6')}>
        {showsTicketStateSwitcher ? (
          <div className="justify-items-center">
            <Skeleton data-testid="loading-purchased-tickets-switcher" className="h-11 w-60 rounded-full" />
          </div>
        ) : null}
        <LoadingPodsSkeleton showDetailsRow={false} />
      </div>
    </InnerPageContainer>
  );
}

export { LoadingPurchasedTickets };
